import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the paths-related API endpoints
export const pathsApi = createApi({
  reducerPath: "pathsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  tagTypes: ["Paths"],
  endpoints: (builder) => ({
    getPaths: builder.query({
      query: ({ projectId }) => `/project/${projectId}/paths`,
    }),
  }),
});

export const { useGetPathsQuery } = pathsApi;
export default pathsApi;
